import { Button, Tooltip, Icon, Dropdown, Menu } from 'antd';
import { FormattedMessage } from 'react-intl';
import React from 'react';
import styles from './WorkflowDetailsFooter.module.scss';
import messages from '../Connect/ConnectMessages';

const create = <FormattedMessage {...messages.create} />;
const saveAs = <FormattedMessage {...messages.saveAs} />;
const save = <FormattedMessage {...messages.save} />;

const updateAndStartWorkflow = <FormattedMessage {...messages.updateAndStartWorkflow} />;
const saveAsAndStartWorkflow = <FormattedMessage {...messages.saveAsAndStartWorkflow} />;

export default function WorkflowDetailsFooter(props) {
  const {
    onSaveWorkflow,
    loadingFlag,
    isSaveDisabled,
    onSaveDraftWorkflow,
    isSaveDraftDisabled,
    isCreate,
    isPreview,
    saveButtonTooltipMessage,
    isDraft,
    isWorkflowLive,
    initiateWorkflowFlag,
    workflowInitiated,
    startWorkflowWindowApiStatus,
    initiateWorkflow,
    isRecommended,
  } = props;
  let saveButtonText = '';
  if (isCreate) saveButtonText = create;
  else if (!isDraft && (isWorkflowLive || isRecommended)) saveButtonText = saveAs;
  else saveButtonText = save;

  const handleDropDown = e => {
    const { key, item } = e;
    e.domEvent.stopPropagation();
    if (item.props.disabled) return;
    if (key === '1') initiateWorkflow({ actionType: 'UpdateAndInitiate' });
    else if (key === '2') initiateWorkflow({ actionType: 'SaveCopyAndStart' });
  };

  const menu = (
    <Menu onClick={handleDropDown}>
      {!isWorkflowLive && !isRecommended ? (
        <Menu.Item key="1" disabled={isWorkflowLive}>
          {updateAndStartWorkflow}
        </Menu.Item>
      ) : null}
      <Menu.Item key="2">{saveAsAndStartWorkflow}</Menu.Item>
    </Menu>
  );

  const getFooterButtonForWorkflowInitation = () => {
    if (isPreview) {
      return (
        <Tooltip title={saveButtonTooltipMessage}>
          <Button
            type="primary"
            shape="round"
            disabled={workflowInitiated === 'true' || isSaveDisabled}
            loading={startWorkflowWindowApiStatus === 'INPROGRESS'}
            onClick={() => {
              initiateWorkflow({ actionType: 'StartExisting' });
            }}
          >
            <FormattedMessage {...messages.startWorkflow} />
          </Button>
        </Tooltip>
      );
    }
    return (
      <Tooltip title={saveButtonTooltipMessage}>
        <Button
          type="primary"
          shape="round"
          disabled={workflowInitiated === 'true' || isSaveDisabled}
          loading={startWorkflowWindowApiStatus === 'INPROGRESS'}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            paddingRight: '0px',
          }}
          onClick={e => {
            e.stopPropagation();
            initiateWorkflow({ actionType: 'CloneAndStart' });
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
            }}
          >
            <FormattedMessage {...messages.startWorkflow} />
            <Dropdown
              overlay={menu}
              onClick={e => e.stopPropagation()}
              trigger={['hover']}
              overlayClassName={styles.saveDropDown}
              overlayStyle={{ minWidth: '250px' }}
              placement="topRight"
            >
              <div className={styles.iconStyle} role="presentation" onClick={e => e.stopPropagation()}>
                <Icon type="down" />
              </div>
            </Dropdown>
          </div>
        </Button>
      </Tooltip>
    );
  };

  return (
    <div className={styles.workflowDetailsFooter}>
      {initiateWorkflowFlag ? (
        <div className={styles.mailWindowFooterbuttonContainer}>{getFooterButtonForWorkflowInitation()}</div>
      ) : (
        <>
          {!isRecommended && (
            <Button shape="round" onClick={onSaveDraftWorkflow} loading={loadingFlag} disabled={isSaveDraftDisabled}>
              <FormattedMessage {...messages.saveDraft} />
            </Button>
          )}
          {saveButtonText ? (
            <Tooltip title={saveButtonTooltipMessage}>
              <Button
                type="primary"
                shape="round"
                onClick={() => onSaveWorkflow({ createNew: [create, saveAs].includes(saveButtonText), redirect: true })}
                loading={loadingFlag}
                disabled={isSaveDisabled}
              >
                {saveButtonText}
              </Button>
            </Tooltip>
          ) : null}
        </>
      )}
    </div>
  );
}
